/**
 * Warehouse filtering shared by WMS document flows.
 *
 * `BRAK` is a virtual defect/write-off destination managed only by RW backend
 * posting and must never be selectable as a regular document warehouse.
 */

/** Returns true when a warehouse may be selected in a regular WMS document. */
export function isOperationalDocumentWarehouse(warehouse: {
  code?: string | null
}) {
  return (
    String(warehouse.code ?? "")
      .trim()
      .toUpperCase() !== "BRAK"
  )
}

/** Removes virtual system warehouses from a document warehouse list. */
export function filterOperationalDocumentWarehouses<
  T extends { code?: string | null },
>(warehouses: T[]): T[] {
  return warehouses.filter(isOperationalDocumentWarehouse)
}
